<template>
    <path d="M7.51732 12.0769H11.4831V10.218H7.51732V12.0769ZM0.577148 0.923096V2.78207H18.4233V0.923096H0.577148ZM3.55151 7.42951H15.4489V5.57053H3.55151V7.42951Z" fill="#00A1DF"/>
</template>

<script>
    export default {
        name: 'icon-filter'
    }
</script>